
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import { optionTaxTransactionCode } from "@/app/infrastructures/misc/Constants";
import { ClientDetailUpdateItem } from '@/domain/entities/ClientManagement';
import DownloadAttachmentPreview from "@/app/ui/components/download-attachment-preview/index.vue";
import { FlagsPermissionClient } from "@/feature-flags/flags-permission-client";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

class Props {
  isManagement = prop<boolean>({
    required: false,
    default: false,
    type: Boolean
  });
}
@Options({
  components: {
    DownloadAttachmentPreview,
    Title
  }
})
class DetailTaxInformation extends Vue.with(Props) {
  get canPreviewAttachment(): boolean {
    return FlagsPermissionClient.permission_client_management_detail_ktp_npwp_view.isEnabled();
  }
  formatDate = formatDate;
  get detailData() {
    if (this.isManagement) {
      return ClientManagementController.detailClientManagement;
    }

    return ClientRegistrationController.clientRegistrationDetail;
  }

  get taxTransactionCode() {
    const transactionCode = this.detailData.clientTax.transactionCode.substr(
      0,
      2
    );

    return (
      optionTaxTransactionCode.find(tc => {
        return tc.value.substr(0, 2) === transactionCode;
      })?.name || this.detailData.clientTax.transactionCode
    );
  }

  get newestUpdated() {
    if (this.detailData.detailUpdate.newestUpdatedTaxInfo.length) {
      return this.detailData.detailUpdate.newestUpdatedTaxInfo[0]
    }

    return new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: formatDate(this.detailData.clientCreatedAt)
    })
  }

  get newestUpdatedTaxAttachment() {
    return this.detailData.detailUpdate.taxInfo?.is_reupload_tax ?? new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: this.detailData.clientCreatedAt as any
    })
  }
}
export default DetailTaxInformation;
